import { render } from "./CollectMonthlyPaymentForm.vue?vue&type=template&id=35ec64f6"
import script from "./CollectMonthlyPaymentForm.vue?vue&type=script&lang=js"
export * from "./CollectMonthlyPaymentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__